// extracted by mini-css-extract-plugin
export default {"form":"Forms_form__doCRf","title":"Forms_title__xqCjo","input":"Forms_input__-J5M1","textarea":"Forms_textarea__uPY5G"};